export default __webpack_public_path__ + "static/media/social-media-arrow.d22f72e1.svg";